function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_inverted_up_1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#F9F9F9",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  d: "M24.0369594,23.0000851 L24.149513,22.9934596 C24.5924713,22.9407322 24.9439154,22.580624 24.9953306,22.1267712 L25.0018132,22.0114786 L25.0014293,8.57974247 L27.3898027,11.0271577 C27.5572737,11.1987466 27.8172365,11.217812 28.0052613,11.084354 L28.0720773,11.0271577 L28.754352,10.3281074 C28.9192063,10.1591996 28.9398131,9.89846427 28.8161723,9.70659961 L28.754352,9.62905699 L24.3776883,5.14487806 L24.3108682,5.08764397 C24.203213,5.01124324 24.0719812,4.98484077 23.9480343,5.00843708 C23.8243821,4.9846988 23.6927328,5.01103731 23.5847874,5.08764397 L23.5179674,5.14487806 L19.1413037,9.62905699 C18.9528988,9.82209442 18.9528988,10.1350699 19.1413037,10.3281074 L19.8235783,11.0271577 C20.0119833,11.2201952 20.3174481,11.2201952 20.505853,11.0271577 L22.8942264,8.57974247 L22.8938425,22.0114786 C22.8938018,22.5184714 23.2662712,22.9363382 23.7461426,22.9934596 L23.8586963,23.0000851 L23.9478278,22.9950851 L24.0369594,23.0000851 Z",
  id: "Path",
  fill: "#ffcc00"
}));

const SvgIcGrayBadgeUp1 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcGrayBadgeUp1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_gray_badge_up_1.a5c25c61.svg";
export { ForwardRef as ReactComponent };